export enum ReportType {
  AssetExport = 'Asset Export',
  AssetSummary = 'Asset Summary',
  AssetGroupSummary = 'Asset Group Summary',
  AssetSchedule = 'Asset Schedule',
  Disposals = 'Disposals',
  Acquisitions = 'Acquisitions',
  DepreciationForecast = 'Depreciation Forecast',
  TaxAudit = 'Tax Audit',
  RevaluationMovements = 'Revaluation Movements',
  Impairments = 'Impairments',
  ClassificationSplit = 'Classification Split',
}
